export default "__VITE_ASSET__DyvsLfaK__"